import { render, staticRenderFns } from "./rotationDashboard.vue?vue&type=template&id=01c1f626&scoped=true"
import script from "./rotationDashboard.vue?vue&type=script&lang=js"
export * from "./rotationDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c1f626",
  null
  
)

export default component.exports